import { useQuery, useMutation } from "react-query";
import {
  createFAQ,
  getFAQList,
  deleteFAQ,
  updateFAQ,
} from "../api/application";
import {
  fileUpload,
  getFileListbyPMSID,
  updateFile,
  deleteFile,
  downloadFile,
} from "../api/file-upload";

// create faq
const useAddNewFAQ = (options = {}) => {
  return useMutation(createFAQ, options);
};

// get faq
const useGetFAQList = (id, options) => {
  return useQuery(["getFAQ", id], () => getFAQList(id), options);
};

// delete faq
const useDeleteFAQ = (options = {}) => {
  return useMutation(deleteFAQ, options);
};

// update faq
const useUpdateFAQ = (options = {}) => {
  return useMutation(updateFAQ, options);
};

// Add bar code config
const useFileUpload = (options = {}) => {
  return useMutation(fileUpload, options);
};

// get bar code config
const useGetFileListbyPMSID = (pmsID, options) => {
  return useQuery(["getFileListPMSID", pmsID], () => getFileListbyPMSID(pmsID), options);
};

// update bar code config
const useUpdateFile = (options = {}) => {
  return useMutation(updateFile, options);
};

// delete bar code config
const useDeleteFile = (options = {}) => {
  return useMutation(deleteFile, options);
};
// Download bar code file
const useDownloadFile = (id, options) => {
  return useQuery(["downloadFile", id], () => downloadFile(id), options);
};

export {
  useAddNewFAQ,
  useGetFAQList,
  useDeleteFAQ,
  useUpdateFAQ,
  useFileUpload,
  useGetFileListbyPMSID,
  useUpdateFile,
  useDeleteFile,
  useDownloadFile,
};
